import { createAsyncAction } from "typesafe-actions";

export const createPush = createAsyncAction(
  "CREATE_PUSH_REQUEST",
  "CREATE_PUSH_SUCCESS",
  "CREATE_PUSH_FAILURE"
)<void, void, Error>();



// WEBPACK FOOTER //
// ./src/actions/pushActions.ts